<template>
  <div id="stent-duo-gezocht">
    <div v-if="!done">
      <h1>Meld je aan</h1>

      <form enctype="multipart/form-data" v-on:submit.prevent="submit">
        <div class="row g-4 gy-md-5 gx-md-6 mb-6">

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.voornaam.length > 0 }">
              <label>Voornaam</label>
              <input type="text" class="form-control" v-model="form.data.voornaam" _required>

              <ul v-if="form.errors.voornaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voornaam" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container">
              <label>Tussenvoegsel</label>
              <input type="text" class="form-control" v-model="form.data.voorvoegsels">

              <ul v-if="form.errors.voorvoegsels.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voorvoegsels" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.achternaam.length > 0 }">
              <label>Achternaam</label>
              <input type="text" class="form-control" v-model="form.data.achternaam" _required>

              <ul v-if="form.errors.achternaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.achternaam" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.geboortedatum.length > 0 }">
              <label>Geboortedatum</label>
              <input type="text" v-model="form.data.geboortedatum" class="spb-field-input form-control"
                placeholder="Formaat: dd-mm-yyyy" _required>

              <ul v-if="form.errors.geboortedatum.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geboortedatum" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-calendar"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container email-container" :class="{ 'error': form.errors.email.length > 0 }">
              <label>E-mailadres</label>
              <input type="email" class="form-control" v-model="form.data.email" _required>

              <ul v-if="form.errors.email.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.email" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-envelope"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.telefoonnummer.length > 0 }">
              <label>Telefoonnummer</label>
              <input type="text" v-model="form.data.telefoonnummer" class="spb-field-input form-control" _required>

              <ul v-if="form.errors.telefoonnummer.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.telefoonnummer" :key="error" class="spb-field-error">{{ error }}</li>
              </ul>

              <i class="btb bt-phone"></i>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container input-file" :class="{ 'error': submitted && form.data.pictures.length === 0 }">
              <label for="pictures">Foto's</label>
              <input id="pictures" name="pictures" class="form-control" type="file" ref="pictures" multiple @change="setPicturesFiles" accept=".png,.jpg,.jpeg,.gif,.webp,.bmp" _required>
              <label for="pictures">
                <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
              </label>


              <ul v-if="submitted && !(form.data.pictures.length > 0)" class="stent-form-errors">
                <li class="spb-field-error">We hebben een foto van u nodig.</li>
              </ul>

              <table v-if="form.data.pictures.length > 0" class="spb-upload-table">
                <tr v-for="(file, index) in form.data.pictures" :key="file">
                  <td class="spb-upload-table-filename">
                    <span>{{ file.name }}</span>
                  </td>

                  <td class="spb-upload-table-remove" @click="removePicturesFile(index)">
                    <span>X</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div v-if="form.data.bijboekers.length > 0">


              <div v-for="(bijboeker, index) in form.data.bijboekers" :key="bijboeker" class="row g-4 gy-md-5 gx-md-6 mb-6" style="margin-top:30px">

                <div class="col-12">
                  <div class="separator-title-container">
                    <h5>Verplichte bijboeker</h5>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.voornaam`] !== undefined }">
                    <label>Voornaam <span class="requirement">(verplicht)</span></label>
                    <input type="text" class="form-control sgt-field-input" v-model="form.data.bijboekers[index].voornaam" data-lpignore="true" _required>

                    <ul v-if="form.errors[`bijboekers.${index}.voornaam`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.voornaam`]" :key="error"
                        class="spb-field-error">{{ error }}</li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container">
                    <label>Tussenvoegsel</label>
                    <input type="text" class="form-control" v-model="form.data.bijboekers[index].voorvoegsels">

                    <ul v-if="form.errors[`bijboekers.${index}.voorvoegsels`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.voorvoegsels`]" :key="error" class="spb-field-error">{{ error }}</li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.achternaam`] !== undefined }">
                    <label>Achternaam</label>
                    <input type="text" class="form-control" v-model="form.data.bijboekers[index].achternaam" _required>

                    <ul v-if="form.errors[`bijboekers.${index}.achternaam`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.achternaam`]" :key="error" class="spb-field-error">{{ error }}</li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.geboortedatum`] !== undefined }">
                    <label>Geboortedatum</label>
                    <input type="text" v-model="form.data.bijboekers[index].geboortedatum" class="spb-field-input form-control"
                      placeholder="Formaat: dd-mm-yyyy" _required>

                    <ul v-if="form.errors[`bijboekers.${index}.geboortedatum`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.geboortedatum`]" :key="error" class="spb-field-error">{{ error }}</li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.email`] !== undefined }">
                    <label>E-mailadres</label>
                    <input type="email" class="form-control" v-model="form.data.bijboekers[index].email" _required>

                    <ul v-if="form.errors[`bijboekers.${index}.email`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.email`]" :key="error" class="spb-field-error">{{ error }}</li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.telefoonnummer`] !== undefined }">
                    <label>Telefoonnummer</label>
                    <input type="text" v-model="form.data.bijboekers[index].telefoonnummer" class="spb-field-input form-control" _required>

                    <ul v-if="form.errors[`bijboekers.${index}.telefoonnummer`] !== undefined" class="stent-form-errors">
                      <li v-for="error in form.errors[`bijboekers.${index}.telefoonnummer`]" :key="error" class="spb-field-error">{{ error }}
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-sm-6 col-md-4">
                  <div class="input-container input-file"
                    :class="{ 'error': submitted && form.errors[`bijboekers.${index}.pictures`] !== undefined }">
                    <label for="bijboeker_pictures">Foto's</label>
                    <input id="bijboeker_pictures" class="form-control" type="file" ref="bijboeker_pictures" multiple
                      @change="setBijboekerPicturesFiles" accept=".png,.jpg,.jpeg,.gif,.webp,.bmp" _required>
                    <label for="bijboeker_pictures">
                      <span class="input-title">Sleep uw bestanden of klik <span>hier</span></span>
                    </label>


                    <ul v-if="submitted && !(form.errors[`bijboekers.${index}.pictures`] !== undefined)" class="stent-form-errors">
                      <li class="spb-field-error">We hebben een foto van u nodig.</li>
                    </ul>

                    <table v-if="form.errors[`bijboekers.${index}.pictures`] !== undefined" class="spb-upload-table">
                      <tr v-for="(file, index) in form.data.bijboekers[index].pictures" :key="file">
                        <td class="spb-upload-table-filename">
                          <span>{{ file.name }}</span>
                        </td>

                        <td class="spb-upload-table-remove" @click="removePicturesFile(index)">
                          <span>X</span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>

              </div>


          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_voorwaarden.length > 0}">
                  <input v-model="form.data.akkoord_voorwaarden" type="checkbox" name="voorwaarden" id="voorwaarden">
                  <label for="voorwaarden">
                    Ik ga akkoord en bevestig dat ik op de hoogte ben van de <a href="/algemene-voorwaarden" target="_blank">Algemene voorwaarden</a>
                    en de <a href="/privacy-policy" target="_blank">Privacy policy</a>.
                  </label>

                  <ul v-if="form.errors.akkoord_voorwaarden.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_voorwaarden" :key="error" class="stt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_bijzondere_persoonsgegevens.length > 0}">
                  <input v-model="form.data.akkoord_bijzondere_persoonsgegevens" type="checkbox" name="akkoord_bijzondere_persoonsgegevens" id="akkoord_bijzondere_persoonsgegevens">
                  <label for="akkoord_bijzondere_persoonsgegevens">
                    Ja, ik geef toestemming voor het verwerken van door mij verstrekte en/of te verstrekken bijzondere persoonsgegevens ten behoeve van de castingprocedure van STENT Casting, zoals beschreven in het Privacy-en Cookiestatement.
                  </label>

                  <ul v-if="form.errors.akkoord_bijzondere_persoonsgegevens.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_bijzondere_persoonsgegevens" :key="error" class="stt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="cell" v-if="!loading">
            <button class="btn btn-primary d-block ms-auto" type="button" data-bs-toggle="modal" data-bs-target="#emailmodal">Verzenden</button>
          </div>

          <div class="cell" v-if="loading">
            <button class="btn btn-primary d-block ms-auto" type="submit" disabled>Aan het laden...</button>
          </div>

          <EmailModal
            :email="this.form.data.email"
            @edit="editEmail"
            @send="sendSubmit"
          />
      </div>

    </form>
  </div>

  <div v-if="done">
    <h1>Aanmelding voltooid</h1>

    <p>De aanmelding is gelukt.</p>
  </div>
  </div>
</template>

<style scoped>
.input-container {
  padding-bottom: 15px;
}

.spb-field-input {
  margin-bottom: 0;
}

.spb-upload-table {
  margin-top: 30px;
  font-size: 14px;
  width:100%;
}

.spb-upload-table td {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipspb;
  white-space: nowrap;
}

.spb-upload-table td.spb-upload-table-filename {
  width: 90%;
}

.spb-upload-table td.spb-upload-table-remove {
  width: 10%;
  color: red;
  font-weight: 900;
  cursor: pointer;
  text-align: right;
}

.form-talent-error-message {
  color: red;
  margin-top: 10px;
  font-size: 14px;
}

#stent-duo-gezocht input[type='file'] {
  width: 1px !important;
  height: 1px !important;
  opacity: 1 !important;
}

.requirement {
  color: #cacaca;
  margin: 0;
  display: inline-block;
  font-size: 14px;
}

.stent-form-errors {
  margin: 0;
  margin-top: 5px;
}

/* .spb-field-error {
  font-size: 14px;
  padding: 0;
}

.spb-field-error::before {
  position: initial;
  display: initial;
  content: " ";
  font-family: Arial;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23d9534f' viewBox='-2 -2 7 7'%3E%3Cpath stroke='%23d9534f' d='M0 0l3 3m0-3L0 3'/%3E%3Ccircle r='.5'/%3E%3Ccircle cx='3' r='.5'/%3E%3Ccircle cy='3' r='.5'/%3E%3Ccircle cx='3' cy='3' r='.5'/%3E%3C/svg%3E");
  padding-right: 1.50rem;
  background-repeat: no-repeat;
  background-size: 1.125rem 1.125rem;
  background-clip: unset;
  background-position-y: -3px;
} */
</style>

<script>
import axios from 'axios';
import helpers from './utils/helpers';
import EmailModal from './components/EmailModal.vue';

export default {
  components: {
    EmailModal,
  },
  data() {
    return {
      form: {
        data: {
          voornaam: '',
          voorvoegsels: '',
          achternaam: '',
          email: '',
          geboortedatum: '',
          telefoonnummer: '',
          pictures: [],
          bijboekers: [
            {
              voornaam: '',
              voorvoegsels: '',
              achternaam: '',
              geboortedatum: '',
              telefoonnummer: '',
              provincie: '',
            }
          ],
          bijboeker_pictures: [],
          opdracht_id: helpers.attribute('opdracht_id'),
          akkoord_voorwaarden: '',
          akkoord_bijzondere_persoonsgegevens: '',
        },

        errors: {
          voornaam: [],
          voorvoegsels: [],
          achternaam: [],
          email: [],
          geboortedatum: [],
          telefoonnummer: [],
          pictures: [],
          bijboekers: [],
          bijboeker_pictures: [],
          opdracht_id: [],
          akkoord_voorwaarden: [],
          akkoord_bijzondere_persoonsgegevens: [],
        },

        response: {},
      },

      loading: false,
      done: false,
    };
  },

  mounted() {
    if (!helpers.attribute('api_endpoint')) return;
  },

  methods: {
    sendSubmit: function () {
      this.loading = true;
      this.submit();
    },
    editEmail: function () {
      this.loading = false;

      helpers.scrollIntoView('.email-container', {
        block: 'center',
      });
    },
    setPicturesFiles() {
      this.form.data.pictures = helpers.fileListToArray(this.form.data.pictures)
        .concat(
          helpers.fileListToArray(this.$refs.pictures.files)
        );
    },

    removePicturesFile(index) {
      helpers.removeFromArrayByIndex(this.form.data.pictures, index);
    },

    setBijboekerPicturesFiles() {
      this.form.data.bijboeker_pictures = helpers.fileListToArray(this.form.data.bijboeker_pictures)
        .concat(
          helpers.fileListToArray(this.$refs.bijboeker_pictures[0].files)
        );
    },

    removeBijboekerPicturesFile(index) {
      helpers.removeFromArrayByIndex(this.form.data.bijboeker_pictures, index);
    },

    submit: function () {
      this.loading = true;

      let formData = new FormData();
      formData.append('voornaam', this.form.data.voornaam);
      formData.append('voorvoegsels', this.form.data.voorvoegsels);
      formData.append('achternaam', this.form.data.achternaam);
      formData.append('email', this.form.data.email);
      formData.append('telefoonnummer', this.form.data.telefoonnummer);
      formData.append('geboortedatum', this.form.data.geboortedatum);
      formData.append('opdracht_id', this.form.data.opdracht_id);
      formData.append('akkoord_voorwaarden', this.form.data.akkoord_voorwaarden);
      formData.append('akkoord_bijzondere_persoonsgegevens', this.form.data.akkoord_bijzondere_persoonsgegevens);

      for (var b_i = 0; b_i < this.form.data.bijboekers.length; b_i++) {
        formData.append(`bijboekers[${b_i}][voornaam]`, this.form.data.bijboekers[b_i].voornaam);
        formData.append(`bijboekers[${b_i}][voorvoegsels]`, this.form.data.bijboekers[b_i].voorvoegsels);
        formData.append(`bijboekers[${b_i}][achternaam]`, this.form.data.bijboekers[b_i].achternaam);
        formData.append(`bijboekers[${b_i}][geboortedatum]`, this.form.data.bijboekers[b_i].geboortedatum);
        formData.append(`bijboekers[${b_i}][telefoonnummer]`, this.form.data.bijboekers[b_i].telefoonnummer);
        formData.append(`bijboekers[${b_i}][provincie]`, this.form.data.bijboekers[b_i].provincie);
      }

      for (var p_i = 0; p_i < this.form.data.pictures.length; p_i++) {
        formData.append(`pictures[${p_i}]`, this.form.data.pictures[p_i]);
      }

      for (var bp_i = 0; bp_i < this.form.data.bijboeker_pictures.length; bp_i++) {
        formData.append(`bijboeker_pictures[${bp_i}]`, this.form.data.bijboeker_pictures[bp_i]);
      }

      axios.post(`${helpers.attribute('api_endpoint')}/api/dashboard/users/create_persoon_duo_aanmelding`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then((response) => {
          this.form.response = response.data;
          this.done = true;
          this.loading = false;

          helpers.scrollIntoView('#stent-duo-gezocht');
        })
        .catch((error) => {
          this.loading = false;

          this.form.errors = {
            ...helpers.setAllObjectPropertiesToArray(this.form.errors),
            ...error.response.data.errors,
          };
        });
    },
  },
};
</script>
